import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { Configuration, ILoggerCallback, InteractionType } from '@azure/msal-browser';

export interface EnvConfig {
    apiUrl: string;
    msalGuardConfig: MsalGuardConfiguration;
    msalInterceptorConfig: MsalInterceptorConfiguration;
    isProduction: boolean;
    isLocalDev: boolean;
    msalConfig: Configuration;
}

export const buildConfig = (args: {
    isProduction: boolean;
    isLocalDev: boolean;
    apiUrl: string;
    interactionType: InteractionType.Popup | InteractionType.Redirect;
    tenantId: string;
    frontendApplicationId: string;
    backendApplicationId: string;
    loggerCallback?: ILoggerCallback
}): EnvConfig => {

    return {
        isProduction: args.isProduction,
        isLocalDev: args.isLocalDev,
        apiUrl: args.apiUrl,
        msalGuardConfig: {
            interactionType: args.interactionType,
        },
        msalInterceptorConfig:
        {
            protectedResourceMap: new Map<string, string[]>(
                args.isLocalDev ? [] :
                    [
                        [`${args.apiUrl}/*`, [`api://${args.backendApplicationId}/Changeovers.Read`]],
                    ]),
            interactionType: args.interactionType,
        },
        msalConfig:
        {
            auth: {
                clientId: args.frontendApplicationId,
                authority: `https://login.microsoftonline.com/${args.tenantId}`,
                redirectUri: window.location.origin,
            },
            system: {
                loggerOptions: {
                    loggerCallback: args.loggerCallback
                }
            }
        },
    };
};
